<div class="formHintText" @demoAnimation>
  {{ "page.login.form.passwordRecovery.info" | translate }}
</div>
<form [formGroup]="passwordRecoveryForm" @demoAnimation>
  <mat-form-field class="w-full" appearance="fill">
    <mat-label>{{ "page.login.form.passwordRecovery.emailField.label" | translate }}</mat-label>
    <input
      matInput
      noWhiteSpace="WIPE"
      id="txtForgotEmail"
      type="text"
      name="emailID"
      placeholder="{{ 'page.login.form.passwordRecovery.emailField.label' | translate }}"
      (focus)="disableAlternativeField('EmailId', 'ClientId')"
      (blur)="enableAllFields()"
      formControlName="EmailId"
    />
    <mat-error *ngIf="passwordRecoveryForm.get('EmailId')?.hasError('email')">
      {{ "page.login.form.passwordRecovery.emailField.invalidMail" | translate }}
    </mat-error>
    <mat-error *ngIf="passwordRecoveryForm.get('EmailId')?.hasError('required')">
      {{ "page.login.form.passwordRecovery.requiredMutuallyExclusiveFieldMessage" | translate }}
    </mat-error>
  </mat-form-field>

  <div class="OrText">OR</div>

  <mat-form-field class="w-full" appearance="fill">
    <mat-label>{{ "page.login.form.passwordRecovery.usernameField.label" | translate }}</mat-label>
    <input
      matInput
      noWhiteSpace="WIPE"
      id="txtForgotUsername"
      type="text"
      name="userID"
      placeholder="{{ 'page.login.form.passwordRecovery.usernameField.label' | translate }}"
      [maxLength]="10"
      (focus)="disableAlternativeField('ClientId', 'EmailId')"
      (blur)="enableAllFields()"
      formControlName="ClientId"
    />
    <mat-error *ngIf="passwordRecoveryForm.get('ClientId')?.hasError('required')">
      {{ "page.login.form.passwordRecovery.requiredMutuallyExclusiveFieldMessage" | translate }}
    </mat-error>
    <mat-error *ngIf="passwordRecoveryForm.get('ClientId')?.hasError('invalidLength')">
      {{ "page.login.form.passwordRecovery.usernameField.invalidLengthMessage" | translate }}
    </mat-error>
  </mat-form-field>

  <div class="BtnWrapper">
    <button
      id="btlForgotPwd"
      kendoButton
      color="primary"
      name="recover-password-button"
      [disabled]="!formIsValid"
      (click)="recoverPassword()"
    >
      {{ "page.login.form.passwordRecovery.recoverButton" | translate }}
    </button>
  </div>
</form>
